var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedPlane({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "34FA6CF0-AF5B-4BDB-AFBB-089595F6BC25") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance-Sub-Category--Approved/Flagged",
    transform: "translate(-1232.000000, -134.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checked",
    transform: "translate(1232.874669, 134.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.97533688,0.45 C8.77715958,0.45 10.4085268,1.18039354 11.5894522,2.36113361 C12.770389,3.54188499 13.5008843,5.17300291 13.5008843,6.97445257 C13.5008843,8.77641295 12.770448,10.4077654 11.5895685,11.5886449 C10.4086367,12.7695767 8.77721987,13.5 6.97533688,13.5 C5.17354646,13.5 3.54217617,12.7695672 2.36127116,11.5886265 C1.18042815,10.4077479 0.45,8.77640328 0.45,6.97445257 C0.45,5.17299754 1.18046802,3.54187425 2.36137105,2.36112093 C3.54225288,1.18038881 5.17356269,0.45 6.97533688,0.45 Z",
    id: "Path",
    stroke: "#113982",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#113982",
    points: "5.81238069 10.2329786 3.02030887 7.44078044 3.95052223 6.51014598 5.81238069 8.37166756 10.0002779 4.18322295 10.9304912 5.11419429"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedPlane);
export default __webpack_public_path__ + "static/media/checkedPlane.bf58eb65c55dc804e023d0741f363f08.svg";
export { ForwardRef as ReactComponent };